import { Grid } from '@mui/material'
import { SimpleForm,  BooleanInput, useTranslate } from 'react-admin'
// import dayjs from 'dayjs'
import { COMMON_FIELDS , HERO_BANNERS_FIELDS} from '../../providers/localization/constant'
import { CreateBase } from '../../components/base'
// import { isAfterDate, isBeforeDate } from '../../utils/validators'
import {
//   ActionSelectInput,
FormBottomToolbarWithPermission,
//   PublicNewsSelectInput,
//   TargetLinkSelectInput,
//   TextInputTargetValue,
} from '../../components/form'
import { ImageDesktopInput } from '../../components/inputs/ImageDesktopInput'
import { ImageMobileInput } from '../../components/inputs/ImageMobileInput'


const BannerCreate = (): JSX.Element => {
    const translate = useTranslate()
//   const defaultDate = dayjs()
//   const defaultExpireDate = defaultDate.add(1, 'month')
  const postDefaultValue = (): object => ({ publish_condition: 'a' })
  return (
    <CreateBase
      title={`${HERO_BANNERS_FIELDS}.create.title`}
      listAction={{
        hasBackButton: true,
      }}
      encType='multipart/form-data'
    >
      <SimpleForm
        toolbar={
            <FormBottomToolbarWithPermission encType='multipart/form-data' hasConfirm={true} isCreate={true} />
          }
        defaultValues={postDefaultValue}
      >
        <Grid item>
            <BooleanInput
              color='primary'
              source='is_active'
              label={`${COMMON_FIELDS}.status.label`}
            />
          </Grid>
        <Grid container spacing={2} alignItems='flex-start' justifyContent='center'>
          <Grid item xs={12} sm={6}>
            <ImageDesktopInput
              label={translate(`${HERO_BANNERS_FIELDS}.image_desktop`)}
              initCrop={false}
              fallbackSource='full_path'
              source='image_desktop'
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <ImageMobileInput
              label={translate(`${HERO_BANNERS_FIELDS}.image_mobile`)}
              initCrop={false}
              fallbackSource='full_path'
              source='image_mobile'
            />
          </Grid>
        </Grid>
      </SimpleForm>
    </CreateBase>
  )
}

export default BannerCreate